export const tabItemClasses = {
  root: "TabItem-root",
  selected: "TabItem-selected",
} as const;
